"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getWorkflowsCreateStatus = exports.getWorkflowsFetchStatus = exports.getWorkflowsDeleteStatus = exports.getWorkflows = void 0;

var _actions = require("./actions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var getWorkflows = function getWorkflows(state) {
  return state.modules.sales.products.quoteAutomation;
};

exports.getWorkflows = getWorkflows;
var getWorkflowsDeleteStatus = (0, _getRequestStatus.default)(_actions.QuoteAutomationActionTypes.DELETE_WORKFLOWS);
exports.getWorkflowsDeleteStatus = getWorkflowsDeleteStatus;
var getWorkflowsFetchStatus = (0, _getRequestStatus.default)(_actions.QuoteAutomationActionTypes.FETCH_WORKFLOWS);
exports.getWorkflowsFetchStatus = getWorkflowsFetchStatus;
var getWorkflowsCreateStatus = (0, _getRequestStatus.default)(_actions.QuoteAutomationActionTypes.CREATE_WORKFLOW);
exports.getWorkflowsCreateStatus = getWorkflowsCreateStatus;